'use strict';

/**
 * set your local API url here
 */
exports.apiUrl = 'https://api2.timedoctor.com';

/**
 * @see https://segment.com/
 * @see https://github.com/aleross/angular-segment-analytics#constant
 */
exports.segmentConfig = {
  /**
   * @see https://github.com/aleross/angular-segment-analytics/blob/master/src/config.js
   */
  // API key: The https://segment.com API key to be used when loading analytics.js.
  // set here value from 'WRITE KEY' from project settings in segment.com
  apiKey: '', // this have to be set with env SEGMENT_API_KEY

  // Autoload: if true, analytics.js will be asynchronously
  // loaded after the app's .config() cycle has ended
  autoload: true,

  // Load delay: number of milliseconds to defer loading
  // analytics.js.
  loadDelay: 0,

  // Condition: callback function to be checked before making an API call
  // against segment. Can be dependency-injected, and is passed the method name
  // and arguments of the analytics.js call being made. Useful for disabling
  // certain or all analytics.js functionality for certain users or in certain
  // application states.
  condition: () => true, // by default ALWAYS TRUE - return false to disable it

  // Debug: turns debug statements on/off. Useful during development.
  // keep it false for production ;)
  debug: false,
};

/**
 * enable/disable debug for $logProvider
 */
exports.logDebugEnabled = false;

// this can be set with env ATATUS_API_KEY
exports.atatusApiKey = '';

exports.silentDownloadUrl = [
  'https://kwc5w69wa3.execute-api.us-east-1.amazonaws.com',
  '/production',
  '/msi-filename-generator?companyId=',
].join('');
